export default {
  titles: {
    locale: 'Välj språk', // Kielivalikon otsikko ruudunlukijoita varten
    search: 'Ange sökkriterier', // Hakulomakkeen otsikko ruudunlukijoita varten
    candidates: 'Kandidater', // Ehdokaslistauksen otsikko ruudunlukijoita varten
    candidateInSocialMedia: 'Kandidaten på sociala medier', // Ehdokkaan somelinkkien otsikko ruudunlukijoita varten
    donationSum: 'Donationssumma',
    companyDetails: 'Namn på företag/samfund',
    donorDetails: 'Donatorns uppgifter',
    thanksForYourDonation: 'Tack för din donation!',
  },
  infoTexts: {
    selectElection: null,
    selectConstituency: 'Börja med att välja en valkrets.',
    selectCommune: 'Välj först kommun.',
    selectWelfareArea: 'Börja med att välja en välfärdsområde.',
    loadingCandidates: 'Laddar kandidater',
    noCandidatesFound: 'Vi hittade inga kandidater med din sökning',
    candidatesFound: 'Din sökning gav en kandidat. | Din sökning gav {count} kandidater.',
    defineSearchTerms: 'Ange sökkriterier för kandidater',
    defineEmbedConfig: 'Ange dina val för inbäddningens inställningar',
    pasteEmbedCode: 'Kopiera och klistra in den här inbäddningskoden till din netsida',
    checkingPayment: 'Verifierar betalning',
    paymentCheckFailed: 'Verifiering av betalning misslyckades',
  },
  candidate: {
    number: 'Kandidatnummer',
    age: 'Ålder',
    years: 'år',
    yearsAbbreviation: 'v',
    independentAbbreviation: 'Obunden',
    donationNotify: 'Donera',
    commune: 'Kommun',
    website: 'Hemsida',
    title: 'Yrke',
  },
  buttons: {
    back: {
      label: 'Tillbaka',
    },
    closeWindow: {
      label: 'Stäng fönstret',
    },
    showMore: {
      label: 'Visa mera',
    },
    showLess: {
      label: 'Visa mindre',
    },
    tryAgain: {
      label: 'Försök på nytt',
    },
    embed: {
      label: 'Skapa inbäddningskod med lista på kandidater',
    },
    donate: {
      label: 'Donera',
    },
    share: {
      label: 'Dela',
    },
    copyLink: {
      card: {
        label: 'Kopiera kandidatkortets länk',
      },
      donation: {
        label: 'Kopiera donationsformulärets länk',
      },
      success: 'Länk kopierad till urklipp.',
      error: 'Kopiering av länk misslyckades. Du kan kopiera länken direkt här.',
    },
    shareInFacebook: {
      label: 'Dela på Facebook',
    },
    shareInTwitter: {
      label: 'Dela på X',
    },
    proceedToPayment: {
      label: 'Gå till betalning',
      notes: 'Penninginsamlingstillstånd:',
    },
    proceedToPaymentService: {
      label: 'Fortsätt till betaltjänsten',
      notes: 'Du kommer automatiskt att omdirigeras till betaltjänsten. Klicka ovan om du inte automatiskt omdirigeras.',
    },
  },
  fields: {
    election: {
      label: 'Val',
    },
    commune: {
      label: 'Kommun',
    },
    constituency: {
      label: 'Valkrets',
    },
    welfareArea: {
      label: 'Välfärdsområde',
    },
    gender: {
      label: 'Kön',
    },
    age: {
      label: 'Ålder',
    },
    sum: {
      label: 'Summa för donation',
      notes: 'Från donationen avdras en serviceavgift som beror på betalningssättet.',
    },
    sumCustom: {
      label: 'Annan summa',
      notes: 'Lägsta summan du kan donera är 5 €.',
    },
    behalfCompany: {
      label: 'Jag donerar för ett företag/samfund',
    },
    organizationName: {
      label: 'Namn på organisation',
    },
    vatId: {
      label: 'FO-nummer',
    },
    organizationType: {
      label: 'Typ av organisation',
    },
    email: {
      label: 'E-post',
    },
    firstName: {
      label: 'Förnamn',
    },
    lastName: {
      label: 'Efternamn',
    },
    donationAbroad: {
      label: 'Jag bor inte i Finland',
    },
    postal: {
      label: 'Postnummer',
    },
    country: {
      label: 'Land',
    },
    locality: {
      label: 'Hemort',
    },
    message: {
      label: 'Meddelande till kandidaten du donerar till',
    },
    donorContact: {
      label: 'Jag går med på att bli kontaktad även i fortsättningen',
      notes: 'Mina uppgifter används enligt dataskyddsbeskrivningen',
    },
    donorPublic: {
      label: 'Donatorn för offentliggöras',
      notes: 'Välj här ifall din donation får offentliggöras. Om du inte inte vill offentliggöra din donation är det bara partiet och kandidaten du donerat till som får veta. Det är frivilligt att offentliggöra donationer för en enskilda kandidat upp till 800 euro. Om du genom tjänsten donerar sammanlagt över 1500 euro, måste donatorn enligt partilagen göras offentlig.',
    },
    donorTermsAccepted: {
      label: 'Jag har bekantat mig med donatorregistrets register- och dataskyddsbeskrivning',
    },
    // Upotuskoodin luonti
    showLocale: {
      label: 'Visa val av språk',
    },
    showSearch: {
      label: 'Visa sökformulär',
    },
    showCommune: {
      label: 'Visa val av kommun',
    },
    showConstituency: {
      label: 'Visa urvalet av valkretsen',
    },
    showWelfareArea: {
      label: 'Visa urvalet av välfärdsområden',
    },
    showGender: {
      label: 'Visa val av kön',
    },
    showAge: {
      label: 'Visa val av ålder',
    },
    showSummary: {
      label: 'Visa sammanfattning av sökresultat',
    },
    autoPager: {
      label: 'Automatisk sidnumrering',
    },
    candidate_type: {
      label: 'Typ av kandidat',
    },
    all: {
      label: 'Alla',
    },
    green_women: {
      label: 'Gröna kvinnor',
    },
    green_youth: {
      label: 'Green ungdomar',
    },
    green_viite: {
      label: 'Viite',
    },
    embedCode: {
      label: 'Inbäddad kod',
    },
  },
}
